import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import { checkDateOnly, required, maxAmountLength } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import Select from 'react-select';
import ExpenseForSelect from '../../../components/ExpenseForSelect';

export class AdditionalItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.amountCreditedOrRefunded = '';
    item.currencyCreditedOrRefunded = '';
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      const item = { ...this.props.item, ...{ ['selectedClaimFor']: selectedClaimFor } };
      this.change(item);
    }
  };
  
  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
      insuredsList,
      isClaimForFieldEnabled,
    } = this.props;
    const selectedClaimForList = !!item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
    ? item.selectedClaimFor.toJS()
    : item.selectedClaimFor || [];

    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
        </div>
        {isClaimForFieldEnabled === true &&
          <div className="row">
            <div className="form-group col-sm-7 col-md-7">
              <ExpenseForSelect
                validatorGroup={validatorGroup}
                validationCounter={validationCounter}
                defaultValue={selectedClaimForList}
                disabled={disabled}
                options={insuredsList}
                onChange={(v) => this.handleChangeInsureds(v)}
                value={selectedClaimForList}
                fieldName={messages.expenseFor}
                tooltipContent={messages.selectInsuredForExpense.defaultMessage}
                messages={messages}
              />
            </div>
            <div className="form-group col-sm-5 col-md-5">
            </div>
          </div>
        }
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.descriptionOfItem}
              fieldName={messages.descriptionOfExpense}
            >
              <Textbox
                disabled={disabled}
                name="descriptionOfItem"
                type="text"
                onChange={this.onChange('descriptionOfItem')}
                value={item.descriptionOfItem}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.descriptionOfExpense}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
                  name="dateOfExpenses"
                  validators={[checkDateOnly, required]}
                  group={validatorGroup}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  defaultValue={item.dateOfdateOfExpensesLoss}
                  fieldName={messages.dateOfExpenses}
                  >
                  <DatePicker
                    name="dateOfExpenses"
                    disabled={disabled}
                    type="text"
                    onDayChange={this.handleDayChange('dateOfExpenses')}
                    value={item.dateOfExpenses}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfExpenses}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateOfExpenses}
                  />
                  </ErrorMessage>
              </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required, maxAmountLength]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimed}
              fieldName={messages.amountClaimed}
              impatientFeedback={true}
            >
              <Textbox
                disabled={disabled}
                name="amountClaimed"
                type="number"
                onChange={this.onChangeAmount('amountClaimed')}
                value={item.amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountClaimed}
                />
              </ErrorMessage>
              <ErrorMessage for="maxAmountLength">
                <FormattedMessage
                  {...messages.amountClaimExceedsMaximumDigits}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currency')}
                disabled={disabled}
                value={item.currency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.haveYouReceivedAnyCreditOrRefundFromTheRentalVehicleCompany} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  type="radio"
                  value="true"
                  checked={item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider === 'true'}
                  onChange={this.onChangeResetReceived('haveYouReceivedAnyCreditOrRefundFromTheServiceProvider')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  type="radio"
                  value="false"
                  checked={item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider === 'false'}
                  onChange={this.onChange('haveYouReceivedAnyCreditOrRefundFromTheServiceProvider')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider === 'true' && (
            <div className={'row'}>
              <div className="form-group col-md-7 col-sm-7">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, maxAmountLength]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.amountCreditedOrRefunded}
                  fieldName={messages.amountCreditedOrRefunded}
                  impatientFeedback={true}
                >
                  <Textbox
                    disabled={disabled}
                    name="amountCreditedOrRefunded"
                    type="number"
                    onChange={this.onChangeAmount('amountCreditedOrRefunded')}
                    value={item.amountCreditedOrRefunded}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.amountCreditedOrRefunded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="maxAmountLength">
                    <FormattedMessage
                      {...messages.amountClaimExceedsMaximumDigits}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.currencyCreditedOrRefunded}
                  fieldName={messages.currency}
                >
                  <CurrencySelector
                    onChange={this.handleCurrencyChange('currencyCreditedOrRefunded')}
                    disabled={disabled}
                    value={item.currencyCreditedOrRefunded}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.currency}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
        )}
      </div>
    );
  }
}

AdditionalItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/components/Additional/AdditionalItem.js